import { DomainModelCollection, ModelTypeDecorator } from '@nts/std';
import { Item } from './item';
import { ItemIdentity } from './item.identity';

@ModelTypeDecorator(Item)
export class ItemCollection extends DomainModelCollection<Item, ItemIdentity> {

}
